export const formatCurrency = (amount) => {
  const isNegative = amount < 0;
  const displayAmount = Math.abs(amount);
  return isNegative ? `-$${displayAmount}` : `$${displayAmount}`;
};
export const currencyFormatter = new Intl.NumberFormat("en-US", {
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});

export const formatDecimalNumber = (value = 0) =>
  `$${currencyFormatter.format(Number(value) || 0)}`;
